import { Outlet, ScrollRestoration } from 'react-router-dom';

export default function RootLayout() {
  const env = import.meta.env.VITE_ENVIRONMENT;
  return (
    <>
      {env === 'dev' && (
        <div style={{ backgroundColor: '#912b88', color: '#FFFFFF', textAlign: 'center' }}>TEST PLATFORM - DEV</div>
      )}
      {env === 'uat' && (
        <div style={{ backgroundColor: '#d4351c', color: '#FFFFFF', textAlign: 'center' }}>TEST PLATFORM - UAT</div>
      )}
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
